// src/events/mange_venue_detsils.js
import React from "react";
import { FaHotel } from "react-icons/fa";
import { FiEdit3, FiSearch, FiPlusCircle } from "react-icons/fi";

const COLORS = {
  primary: "#f20c53",
  secondary: "#fb6c33",
  text: "#0f172a",
  subtext: "#475569",
  border: "#e2e8f0",
  page: "#f5f6f8",
  card: "#ffffff",
};

export default function MangeVenueDetsils() {
  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gap: 16 }}>
      <section
        style={{
          background: COLORS.card,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 14,
          boxShadow: "0 1px 2px rgba(0,0,0,.05)",
          padding: 16,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <div
            style={{
              width: 34,
              height: 34,
              display: "grid",
              placeItems: "center",
              borderRadius: 8,
              background: "#fff",
              border: `1px solid ${COLORS.border}`,
              color: COLORS.primary,
            }}
          >
            <FaHotel />
          </div>
          <div style={{ fontWeight: 900, fontSize: 18, color: COLORS.text }}>
            Manage Venue (Dummy)
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: 12,
            marginBottom: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ position: "relative", width: "100%" }}>
              <FiSearch
                style={{ position: "absolute", left: 10, top: 12, color: COLORS.subtext }}
              />
              <input
                placeholder="Search your venues…"
                style={{
                  width: "100%",
                  height: 42,
                  padding: "0 12px 0 34px",
                  border: `1px solid ${COLORS.border}`,
                  borderRadius: 10,
                  outline: "none",
                }}
              />
            </div>
          </div>
          <button
            type="button"
            style={{
              height: 42,
              padding: "0 14px",
              borderRadius: 10,
              border: "none",
              color: "#fff",
              fontWeight: 800,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: `linear-gradient(90deg, ${COLORS.primary}, ${COLORS.secondary})`,
            }}
            // TODO: link to Add Venue tab if needed
          >
            <FiPlusCircle /> Add Venue
          </button>
        </div>

        {/* Dummy venue list */}
        <div style={{ display: "grid", gap: 10 }}>
          {[1, 2].map((i) => (
            <div
              key={i}
              style={{
                border: `1px solid ${COLORS.border}`,
                borderRadius: 12,
                padding: 12,
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div>
                <div style={{ fontWeight: 800, color: COLORS.text }}>Sample Venue {i}</div>
                <div style={{ fontSize: 13, color: COLORS.subtext, marginTop: 4 }}>
                  Status: <b>pending</b> • City: Mumbai • Type: Indoor
                </div>
              </div>
              <button
                type="button"
                style={{
                  height: 38,
                  padding: "0 12px",
                  borderRadius: 10,
                  border: `1px solid ${COLORS.border}`,
                  background: "#fff",
                  color: COLORS.text,
                  fontWeight: 700,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                }}
                // TODO: open venue details / edit page
              >
                <FiEdit3 /> View / Edit
              </button>
            </div>
          ))}
        </div>

        {/* NOTE: hook Firestore "new_venues" here later */}
      </section>
    </div>
  );
}
